import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-landing-layout',
    templateUrl: './landing-layout.component.html',
    styleUrls: ['./landing-layout.component.css'],
    standalone: false
})
export class LandingLayoutComponent implements OnInit {
  apiStatus: string = 'open';
  showOpenApi: boolean = true;
  showFixApi: boolean = false;
  showBackOfficeApi: boolean = false;
  constructor() {
  }

  ngOnInit(): void {
  }
  apiEventHandle(e: any): void {
    this.apiStatus = e;
    this.showOpenApi = e == 'open' ? true : false;
    this.showFixApi = e == 'fix' ? true : false;
    this.showBackOfficeApi = e == 'backOffice' ? true : false;
  }
}
